import React from 'react'
import './Resume.css'
import { VerticalTimeline, VerticalTimelineElement } from 'react-vertical-timeline-component';
import 'react-vertical-timeline-component/style.min.css';
import StarIcon from '@material-ui/icons/Star';


function Resume() {
    return (
        <>
            <section id="resume" style={{ scrollSnapAlign: 'start' }}>
                <div className="resume-container">
                    <div className="resume-section-title">
                        <h1>./Experience</h1>
                    </div>
                    <div className="resume-content">
                        <VerticalTimeline layout='2-columns'>
                            <VerticalTimelineElement
                                className="vertical-timeline-element--work"
                                contentStyle={{ background: '#212121', color: 'white', borderRight: '3px solid #048300', borderRadius: '20px', boxShadow: 'none' }}
                                contentArrowStyle={{ borderRight: '7px solid  #048300', marginLeft: '3px' }}
                                date="May 2023 - Present"
                                iconStyle={{ background: '#048300', color: '#fff' }}
                                icon={<img src={"/images/logo/Cisco.png"} alt="Cisco" className='logo_icon' />}
                            >
                                <h3 className="vertical-timeline-element-title">Software Engineer - III</h3>
                                <h4 className="vertical-timeline-element-subtitle">Cisco</h4>
                                <hr className='hr_green' />
                                <h4 className="vertical-timeline-element-subtitle">Bangalore, India</h4>

                            </VerticalTimelineElement>
                            <VerticalTimelineElement
                                className="vertical-timeline-element--work"
                                contentStyle={{ background: '#212121', color: 'white', borderLeft: '3px solid #048300', borderRadius: '20px', boxShadow: 'none' }}
                                contentArrowStyle={{ borderRight: '7px solid  #048300', marginRight: '2.5px' }}
                                date="Jul 2021 - May 2023"
                                iconStyle={{ background: '#048300', color: '#fff' }}
                                // icon={<WorkIcon />}
                                icon={<img src={"/images/logo/Mavenir.png"} alt="Mavenir" className='logo_icon' />}
                            >
                                <h3 className="vertical-timeline-element-title">Member of Technical Staff - I</h3>
                                <h4 className="vertical-timeline-element-subtitle">Mavenir</h4>
                                <hr className='hr_green' />
                                <h4 className="vertical-timeline-element-subtitle">Bhubaneswar, India</h4>

                            </VerticalTimelineElement>
                            <VerticalTimelineElement
                                className="vertical-timeline-element--education"
                                contentStyle={{ background: '#212121', color: 'white', borderRight: '3px solid #048300', borderRadius: '20px', boxShadow: 'none' }}
                                contentArrowStyle={{ borderRight: '7px solid  #048300', marginLeft: '3px' }}
                                date="Aug 2017 - Jun 2021"
                                iconStyle={{ background: '#048300', color: '#fff' }}
                                icon={<img src={"/images/logo/VSSUT.png"} alt="VSSUT" className='logo_icon' />}
                            >
                                <h3 className="vertical-timeline-element-title">Computer Science and Engineering</h3>
                                <h4 className="vertical-timeline-element-subtitle">Bachelor of Technology</h4>
                                <hr className='hr_green' />
                                <p>
                                    Veer Surendra Sai University of Technology, Burla
                                </p>
                            </VerticalTimelineElement>
                            <VerticalTimelineElement
                                className="vertical-timeline-element--work"
                                contentStyle={{ background: '#212121', color: 'white', borderLeft: '3px solid #048300', borderRadius: '20px', boxShadow: 'none' }}
                                contentArrowStyle={{ borderRight: '7px solid  #048300', marginRight: '2.5px' }}
                                date="Dec 2020 - Jun 2021"
                                iconStyle={{ background: '#048300', color: '#fff' }}
                                icon={<img src={"/images/logo/ChargebackGurus.png"} alt="ChargebackGurus" className='logo_icon' />}
                            >
                                <h3 className="vertical-timeline-element-title">Data Analytics Intern</h3>
                                <h4 className="vertical-timeline-element-subtitle">Chargeback Gurus</h4>
                                <hr className='hr_green' />
                                <h4 className="vertical-timeline-element-subtitle">Chennai, India</h4>

                            </VerticalTimelineElement>
                            <VerticalTimelineElement
                                className="vertical-timeline-element--work"
                                contentStyle={{ background: '#212121', color: 'white', borderRight: '3px solid #048300', borderRadius: '20px', boxShadow: 'none' }}
                                contentArrowStyle={{ borderRight: '7px solid  #048300', marginLeft: '3px' }}
                                date="Apr 2020 - Aug 2020"
                                iconStyle={{ background: '#048300', color: '#fff' }}
                                icon={<img src={"/images/logo/DigitalTesseract.png"} alt="DigitalTesseract" className='logo_icon' />}
                            >
                                <h3 className="vertical-timeline-element-title">ML & AI Intern</h3>
                                <h4 className="vertical-timeline-element-subtitle">Digital Tesseract</h4>
                                <hr className='hr_green' />
                                <h4 className="vertical-timeline-element-subtitle">Chennai, India</h4>

                            </VerticalTimelineElement>
                            <VerticalTimelineElement
                                className="vertical-timeline-element--work"
                                contentStyle={{ background: '#212121', color: 'white', borderLeft: '3px solid #048300', borderRadius: '20px', boxShadow: 'none' }}
                                contentArrowStyle={{ borderRight: '7px solid  #048300', marginRight: '2.5px' }}
                                date="Dec 2018 - Jan 2019"
                                iconStyle={{ background: '#048300', color: '#fff' }}
                                icon={<img src={"/images/logo/CDAC.png"} alt="CDAC" className='logo_icon' />}
                            >
                                <h3 className="vertical-timeline-element-title">HPC & DL Intern</h3>
                                <h4 className="vertical-timeline-element-subtitle">Center for Development of Advanced Computing</h4>
                                <hr className='hr_green' />
                                <h4 className="vertical-timeline-element-subtitle">Pune, India</h4>

                            </VerticalTimelineElement>


                            <VerticalTimelineElement
                                className="vertical-timeline-element--end"
                                contentStyle={{ background: 'transparent', boxShadow: 'none', border: 'none' }}
                                contentArrowStyle={{ borderRight: 'none' }}
                                iconStyle={{ background: '#000', color: '#fff' }}
                                icon={<StarIcon />}
                            />
                        </VerticalTimeline>
                    </div>
                </div>
            </section>
        </>
    )
}

export default Resume